import { createContext, useContext } from "react";

export type ProposalPremiumDisplayContextValue = {
  /** Full-viewport cover — sticky tab nav sits below the fixed Clarity logo. */
  fullViewportCover?: boolean;
};

const defaultValue: ProposalPremiumDisplayContextValue = {};

export const ProposalPremiumDisplayContext = createContext<ProposalPremiumDisplayContextValue>(defaultValue);

export function useProposalPremiumDisplay(): ProposalPremiumDisplayContextValue {
  return useContext(ProposalPremiumDisplayContext);
}
